import { AuthenticatedFileDownload } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'
import type { RequirementQueryParams } from '@eggplant/types'

interface Props {
  params: RequirementQueryParams
  onSuccess: () => void
  children?: () => ReactElement
}

const ExportRequirementsRequest = ({
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${MODELER_SERVICE}/requirements`

  return (
    <AuthenticatedFileDownload
      children={children}
      fileType='text/csv'
      filename='requirements.csv'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default ExportRequirementsRequest
